import React from "react";
import { motion } from "framer-motion";
import AboutContent from "./AboutContent";
import ProfileImage from "./ProfileImage";

function About() {
  return (
    <motion.div
      initial={{ y: -360, x: 60, opacity: 0 }}
      animate={{ y: 0, x:0, opacity: 1 }}
      transition={{ delay: 0.1, duration: 3 }}
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
    >
      <AboutContent />
      <ProfileImage />
    </motion.div>
  );
}

export default About;
